<ng-container *ngIf="!vm.guid">
  <app-skeleton-loader class="fill mt-40 h-32"> </app-skeleton-loader>
  <app-skeleton-loader class="fill mt-12 max-w-320 h-32"> </app-skeleton-loader>

  <app-skeleton-loader class="fill mt-20" />

  <app-skeleton-loader class="mt-20 fill p-16">
    <app-skeleton-loader class="fill max-w-240 h-28" />
    <app-skeleton-loader class="fill mt-12" />

    <section class="flex full-width gap-12" style="flex: 1">
      <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
      <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
    </section>

    <section
      class="flex full-width gap-12"
      style="flex: 1; justify-content: space-between"
    >
      <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
      <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
    </section>
  </app-skeleton-loader>
</ng-container>

<ng-container *ngIf="vm.guid">
  <div>
    <p class="header heading-4 mb-8">Find your model number</p>
    <p class="body">
      You’ll see this number on a plate or sticker on your
      {{ vm.productDescription }}.
    </p>
    <p class="body">Please enter it here.</p>
  </div>

  <div>
    <app-text-search
      name="item_product"
      placeHolder="Start typing to search..."
      [ngModel]="modelValue"
      [guid]="vm.guid"
      [options]="vm.options"
      [loading]="vm.loading"
      [exampleText]="'For example ABC123456789'"
      (textChanged)="onTextChange($event)"
      (loadingData)="loadingData.emit($event)"
      (ngModelChange)="onChange($event)"
      (emptyResponse)="onEmptyResponse()"
    />

    <!--not sure if this is best way?-->
    @if (vm.errorMessage) {
    <section class="error">
      <i class="fa-light fa-circle-exclamation"></i>
      <p class="body">{{ vm.errorMessage }}</p>
    </section>
    }
  </div>

  <section class="flex-col gap-8">
    <p class="label gap-8">Why do we need this?</p>

    <ul class="why-do-we-need-this flex-col gap-8">
      <li class="body">
        <i class="fa-light fa-check mt-4"></i>
        It helps us identify what’s wrong, so we can fix it
      </li>
      <li class="body">
        <i class="fa-light fa-check mt-4"></i>
        It allows us to bring the right parts for your appliance
      </li>
    </ul>
  </section>

  <section class="panel" [class.open]="vm.panelExpanded">
    <section class="header">
      <button
        type="button"
        class="label flex body large"
        (click)="panelExpanded.set(!vm.panelExpanded)"
      >
        <span> Where to find the number </span>

        <i
          class="fa-regular"
          [class.fa-chevron-up]="vm.panelExpanded"
          [class.fa-chevron-down]="!vm.panelExpanded"
        ></i>
      </button>
    </section>

    <section [appAnimateOpen]="vm.panelExpanded" class="content">
      <section class="flex-col gap-8 full-width mt-8">
        <ul class="where-to-find flex-col gap-8">
          <li class="body">In your appliance’s user manual</li>
          <li class="body">
            On a label on the side of your appliance or inside the door (look
            for a number called “model” or “mod”)
          </li>
        </ul>

        @if (vm.brandImage) {
        <section class="p-16">
          <img
            class="max-w-298 block mx-auto"
            [src]="'assets/images/model-number-diagrams/' + vm.brandImage"
            alt=""
          />
        </section>
        }

        <label class="checkbox">
          <input
            type="checkbox"
            id="cannot-find-number"
            name="cannot-find-number"
            class="cannot-find-number-checkbox"
            [(ngModel)]="stillCantFindNumber"
            (change)="sendCannotFindNumber()"
          />
          <span class="box">
            <svg
              class="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="13"
              viewBox="0 0 17 13"
              fill="none"
            >
              <path
                d="M14.3779 1.5957C14.921 1.07338 15.7987 1.07344 16.3418 1.5957C16.3486 1.60222 16.3535 1.61105 16.3594 1.61816C16.8863 2.14774 16.8801 2.99272 16.3389 3.51367L7.19629 12.3125C6.65317 12.8347 5.77546 12.8349 5.23242 12.3125L0.661133 7.91309C0.112572 7.38512 0.112572 6.52308 0.661133 5.99512C1.20428 5.47241 2.0828 5.47245 2.62598 5.99512L6.21582 9.44727L14.3779 1.5957Z"
                fill="#0065C4"
                stroke="#0065C4"
                stroke-width="0.5"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="cannot-find-number-text label"
            >I still can't find the number</span
          >
        </label>
      </section>
    </section>
    <div>
      <div class="divider"></div>
    </div>
    @if (vm.stillCantFindNumber) {
    <section class="number-is-important p-16 flex-col gap-8 mb-16">
      <p class="label">
        <i class="fa-light fa-circle-exclamation"></i>
        This number is important
      </p>

      <p class="body">It allows us to:</p>

      <ul class="flex-col gap-8">
        <li class="body">
          Understand exactly what’s wrong with your appliance
        </li>
        <li class="body">Bring the right parts on the first visit</li>
      </ul>

      <p class="body">
        Without the number, your repair will probably take
        <strong>more than one visit.</strong>
      </p>
    </section>
    }
  </section>
</ng-container>
